export default __webpack_public_path__ + "static/media/Play_Scissors.7af78f8e.png";